import React from 'react';
import { Route, Switch } from 'react-router';
import CreateDisciplines from './create';
import EditDisciplines from './edit';
import ViewDisciplines from './view';

const Disciplines = () => {
  return (
    <Switch>
      <Route exact path='/admin/disciplines' component={ViewDisciplines} />
      <Route
        exact
        path='/admin/disciplines/new'
        component={CreateDisciplines}
      />
      <Route exact path='/admin/disciplines/:id' component={EditDisciplines} />
    </Switch>
  );
};

export default Disciplines;
